import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Card, CardHeader, Skeleton, Typography } from '@mui/material';
import { t } from 'i18next';
import { ComponentLoader } from '../../../../../common/components/ComponentLoader';
import { ObjectDataViewer } from '../../../../../common/components/ObjectDataViewer';

type Props = {
  details: object | null;
  loading: boolean;
  initialLoad: boolean;
};

export const Details = ({ details, loading, initialLoad }: Props) => {
  if (initialLoad) {
    return (
      <Card>
        <CardHeader title={<Skeleton width={100} />} />
      </Card>
    );
  }

  if (!details) {
    return null;
  }

  return (
    <ComponentLoader loading={loading}>
      <Accordion className="instance-details">
        <AccordionSummary
          expandIcon={<ExpandMore />}
          id="instance-details-header"
          aria-controls="instance-details-panel"
          title={t('a11y.report.issues.instanceDetailsAccordion')}
        >
          <Typography component="span" variant="h5">
            {t('details')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ObjectDataViewer value={details} loading={loading} />
        </AccordionDetails>
      </Accordion>
    </ComponentLoader>
  );
};
